/* eslint-disable import/no-default-export */
// @flow

import { DynamicInput } from './DynamicInput';

export default DynamicInput;
